import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"
import { useNavigate } from "react-router-dom"
import useAppPromotionTheme from "../hooks/useAppPromotionTheme"

export default function GrandBaccarat({ isLightMode }) {
  const isAppPromo = useAppPromotionTheme(isLightMode)
  const data = promotionsData.find((promo) => promo.title === "Grand Baccarat")
  const [isMobile, setIsMobile] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  // Promo expired
  useEffect(() => {
    if (!data) {
      navigate("/not-found")
    }
  }, [data, navigate])

  if (!data) return null

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Grand Baccarat</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a
                href={
                  isAppPromo
                    ? "/promotion/".replace("/promotion", "/app-promotion")
                    : "/promotion"
                }
              >
                Promotions
              </a>
              / <span>{data.title}</span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH${data.title}`}
              />
              <div className="promotion-tnc-content">
                <div className="promotion-tnc-info">
                  <div
                    className={`promotion-indication-message ${data.promotionMessage.class}`}
                  >
                    {data.promotionMessage.text}
                  </div>
                  <h1>Grand Baccarat</h1>
                  <h2>Live Casino Promotion</h2>
                  <div className="promotion-tnc-period">
                    <strong>Event Period</strong>
                    <span> June 11 - June 26</span>
                  </div>
                </div>
                <div className="promotion-tnc-mechanic-content">
                  <strong>Terms and Conditions</strong>
                  <ol>
                    <li>
                      40,000 prizes with a prize pool of ₱240,000,000 will be
                      given out from 11 June 2026 00:00 to 26 June 2026 23:59
                      (GMT+8).
                    </li>
                    <li>
                      There are 2 prize drops during the promotion period,
                      running as per the schedule below: Schedule:
                    </li>
                    <ul>
                      <li>
                        Phase 1: 11 June 00:00 – 17 June 23:59 (GMT+8): with
                        25,000 winners and prizes worth up to ₱150,000,000
                      </li>
                      <li>
                        Phase 2: 18 June 00:00 – 26 June 23:59 (GMT+8): with
                        15,000 winners and prizes worth up to ₱90,000,000
                      </li>
                    </ul>
                    <li>
                      To qualify, players must place a real money bet of minimum
                      ₱20 on any baccarat table.
                    </li>
                    <li>
                      Prizes will be given in the form of 10 Free Chips, with
                      each chip valued at ₱40 or its equivalent in other
                      currencies.
                    </li>
                    <li>
                      Free chips can only be used on the following baccarat
                      tables: Seotda Baccarat, Korean Speed, Baccarat 1, Korean
                      Speed Baccarat 2, Korean Baccarat 1, Speed Baccarat 1,
                      Baccarat 1, Indonesian Speed Baccarat 1, Chinese Speed
                      Baccarat 1, Thai Speed Baccarat 1 and Vietnamese Speed
                      Baccarat 1.
                    </li>
                    <li>
                      Free chips cannot be combined with real money bet and in
                      each round players can only place a maximum of 4 chips per
                      bet.
                    </li>
                    <li>
                      Total win from each prize is capped at ₱6,000. Once
                      maximum win limit is reached, remaining Free Chips will be
                      forfeited.
                    </li>
                    <li>
                      Players can choose to play Free Chips instantly or later.
                      Free Chips will be valid for 3 days from the time of
                      awarding, after which they will expire.
                    </li>
                    <li>
                      Winnings from Free Chips has no wagering requirement.
                    </li>
                    <li>
                      Each player may win up to 2 prizes in Phase 1 prize drops
                      and 1 prize in Phase 2 prize drops. The maximum win value
                      per player is ₱18,000.
                    </li>
                    <li>
                      Pragmatic Play reserves the right to amend, suspend or
                      cancel the promotion at any time and without prior notice.
                    </li>
                  </ol>
                  <strong>Prize Pool</strong>
                  <div className="table-wrapper">
                    <table
                      className="promotion-tnc-table"
                      style={{ minWidth: "0" }}
                    >
                      <thead>
                        <th>Number of Prizes</th>
                        <th>Prizes</th>
                      </thead>
                      <tbody>
                        <tr>
                          <td>25,000</td>
                          <td>10 Free Chips</td>
                        </tr>
                      </tbody>
                    </table>
                    <strong>Minimum Bet Size</strong>
                    <div className="table-wrapper">
                      <table className="table-wrapper">
                        <table
                          className="promotion-tnc-table"
                          style={{ minWidth: "0" }}
                        >
                          <thead>
                            <th>Minimum Bet Size</th>
                          </thead>
                          <tbody>
                            <tr>
                              <td>20</td>
                            </tr>
                          </tbody>
                        </table>
                      </table>
                      {!isAppPromo && (
                        <div className="promotion-tnc-cta">
                          <a className="promotion-cta-btn" href="/live-casino/">
                            PLAY NOW
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
